function YesNoIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          d='M7.98438 19H6.01563V14.9746L2.5 9H4.82031L6.00156 11.3588L6.98594 13.3503H7.02813C7.35156 12.6864 7.66094 12.065 7.99844 11.3588L9.17969 9H11.5L7.98438 14.9746V19Z'
          fill='currentColor'
        />
        <path
          d='M23.4826 26.8745H21.5V17H23.3257L26.8344 21.1841C27.3764 21.8536 27.9184 22.5091 28.5745 23.3877H28.6173C28.5174 22.5091 28.5032 21.8396 28.5032 20.9052V17H30.5V27H29.088L25.1941 22.4393C24.6379 21.7838 24.0816 21.1004 23.4113 20.2357H23.3827C23.4683 21.1004 23.4826 21.7838 23.4826 22.7183V26.8745Z'
          fill='currentColor'
        />
        <path
          d='M19.5 5L12.4992 29.0459'
          strokeWidth='2'
          strokeLinecap='round'
          stroke='currentColor'
        />
      </svg>
    </span>
  );
}

export default YesNoIcon;
